export default __webpack_public_path__ + "static/andre@2x-1814a8c97a76eb2efee38e3d6a30f1e7.jpg";